// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__bTw67","right":"Footer_right__3Ms_t","buttons":"Footer_buttons__3gJgR"};